import type { ICompanyModel } from '../models/ICompanyModel';
import api from './kyAuthenticatedInstance';

export const CompanyService = {
	async getCompanies<T>(): Promise<T> {
		return api.get(`Companies`).json<T>();
	},
	async getRoles<T>(): Promise<T> {
		return api.get(`Account/Roles`).json<T>();
	},
	async getCompany<T>(companyId: number): Promise<T> {
		return api.get(`Companies/${companyId}`).json<T>();
	},
	async createCompany(company: Partial<ICompanyModel>): Promise<Response> {
		const correctedCompany = {
			organizationNumber: company.organizationNumber,
			companyTypeId: company.companyTypeId,
			copyDemoData: company.copyDemoData
		};

		return api.post(`Companies`, {
			json: {
				...correctedCompany
			}
		});
	},
	async updateCompany(
		company: Pick<
			ICompanyModel,
			| 'name'
			| 'companyId'
			| 'organizationNumber'
			| 'contactPhoneNumber'
			| 'contactEmail'
			| 'companyTypeId'
			| 'active'
		>
	): Promise<Response> {
		const { companyId, ...body } = company;
		return api.put(`Companies/${companyId}`, {
			json: {
				...body
			}
		});
	},
	async deleteCompany(companyId: number): Promise<Response> {
		return api.delete(`Companies/${companyId}`);
	},
	async addCompanyModule(companyId: number, moduleName: string): Promise<Response> {
		return api.put(`Companies/${companyId}/module?moduleName=${moduleName}`);
	}
};
